import { render, staticRenderFns } from "./notFoundPage.vue?vue&type=template&id=76214aa4&"
import script from "./notFoundPage.vue?vue&type=script&lang=js&"
export * from "./notFoundPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports